

        <div class="coming-soon-modal">
            <div class="text-center">
                <img class="img" src="assets/img/email-icon-green.svg" alt="">
                <h3>{{ data?.message }}</h3>
                <p>{{ data?.message2 }}</p>
                <button class="btn-link" type="button" (click)="onNoClick()">CLOSE</button>
            </div>
        </div>